const uuid = () => {
  // snaked from MozDev
  const min = Math.ceil(1);
  const max = Math.floor(Number.MAX_SAFE_INTEGER);
  return `${Math.floor(Math.random() * (max - min + 1)) + min}`;
}

module.exports = {
  uuid,
}



// WEBPACK FOOTER //
// ./shared/lib/uuid.js